/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as RequestBodyTypes from '../request-bodies/types'
import * as ResponseTypes from '../responses/types'
import * as SchemaTypes from '../schema/types'
import * as UtilityTypes from '../utilities/types'

import * as TransactionsPublicTypes from './types'

export type LoanTransactionsGetAllKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  unknown,
]

export type LoanTransactionsGetAllResponse = ResponseTypes.TransactionCollection

export type LoanTransactionsGetAllVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: {
    status?: Array<SchemaTypes.TransactionStatusReadOnly>
    paymentInstrumentId?: SchemaTypes.AnyId
    isExternal?: boolean
    isVirtual?: boolean
    transactionType?: 'payment' | 'serviceCredit'
    paymentReason?:
      | 'autoPay'
      | 'settlement'
      | 'reversal'
      | 'downPayment'
      | 'oneTimePayment'
      | 'reimbursement'
    retryOriginalTransactionId?: string
    serviceCreditTypes?: Array<SchemaTypes.serviceCreditTypes>
    toEffectiveDate?: string
    fromEffectiveDate?: string
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    sortBy?: Array<
      | 'appliedAt'
      | '+appliedAt'
      | '-appliedAt'
      | 'createdAt'
      | '+createdAt'
      | '-createdAt'
      | 'effectiveDate'
      | '+effectiveDate'
      | '-effectiveDate'
      | 'displayDate'
      | '+displayDate'
      | '-displayDate'
    >
  }
}

export const loanTransactionsGetAll = makeData<
  LoanTransactionsGetAllResponse,
  LoanTransactionsGetAllKey,
  LoanTransactionsGetAllVariables
>({
  method: 'get',
  name: 'loanTransactionsGetAll',
  summary: 'Get transactions',
  path: '/people/{personId}/loans/{loanId}/transactions',
  queryKey: ({ query, personId, loanId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    query,
  ],
})

export type TransactionsCreateKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  unknown,
]

export type TransactionsCreateResponse = UtilityTypes.SingletonResponse & {
  data?: SchemaTypes.Transaction
}

export type TransactionsCreateVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: SchemaTypes.CreateTransaction
  query?: {
    sync?: boolean
  }
}

export const transactionsCreate = makeData<
  TransactionsCreateResponse,
  TransactionsCreateKey,
  TransactionsCreateVariables
>({
  method: 'post',
  name: 'transactionsCreate',
  summary: 'Create transaction',
  path: '/people/{personId}/loans/{loanId}/transactions',
  queryKey: ({ query, personId, loanId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    query,
  ],
})

export type TransactionsGetByIdKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  unknown,
]

export type TransactionsGetByIdResponse = UtilityTypes.SingletonResponse & {
  data?: SchemaTypes.Transaction
}

export type TransactionsGetByIdVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: void
}

export const transactionsGetById = makeData<
  TransactionsGetByIdResponse,
  TransactionsGetByIdKey,
  TransactionsGetByIdVariables
>({
  method: 'get',
  name: 'transactionsGetById',
  summary: 'Get transaction by ID',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}',
  queryKey: ({ query, personId, loanId, transactionId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    query,
  ],
})

export type TransactionsUpdateKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  unknown,
]

export type TransactionsUpdateResponse = UtilityTypes.SingletonResponse & {
  data?: SchemaTypes.Transaction
}

export type TransactionsUpdateVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: SchemaTypes.TransactionUpdateExternal
  query?: {
    sync?: boolean
  }
}

export const transactionsUpdate = makeData<
  TransactionsUpdateResponse,
  TransactionsUpdateKey,
  TransactionsUpdateVariables
>({
  method: 'put',
  name: 'transactionsUpdate',
  summary: 'Update transaction',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}',
  queryKey: ({ query, personId, loanId, transactionId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    query,
  ],
})

export type TransactionCancelKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'cancel',
  unknown,
]

export type TransactionCancelResponse = void

export type TransactionCancelVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: {
    cancelReason?: SchemaTypes.TransactionCancelReason
    clearExternalId?: boolean
  }
}

export const transactionCancel = makeData<
  TransactionCancelResponse,
  TransactionCancelKey,
  TransactionCancelVariables
>({
  method: 'post',
  name: 'transactionCancel',
  summary: 'Cancel transaction',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}/cancel',
  queryKey: ({ query, personId, loanId, transactionId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'cancel',
    query,
  ],
})

export type TransactionsFailMultipleKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  'fail',
  unknown,
]

export type TransactionsFailMultipleResponse =
  TransactionsPublicTypes.ResponseFailMultipleTransactions

export type TransactionsFailMultipleVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: TransactionsPublicTypes.RequestBodyFailMultipleTransactions
  query?: {
    sync?: boolean
  }
}

export const transactionsFailMultiple = makeData<
  TransactionsFailMultipleResponse,
  TransactionsFailMultipleKey,
  TransactionsFailMultipleVariables
>({
  method: 'post',
  name: 'transactionsFailMultiple',
  summary: 'Fail multiple transactions',
  path: '/people/{personId}/loans/{loanId}/transactions/fail',
  queryKey: ({ query, personId, loanId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    'fail',
    query,
  ],
})

export type TransactionReverseKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'reverse',
  unknown,
]

export type TransactionReverseResponse = ResponseTypes.Transaction

export type TransactionReverseVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: RequestBodyTypes.ReversalPost
  query?: {
    sync?: boolean
  }
}

export const transactionReverse = makeData<
  TransactionReverseResponse,
  TransactionReverseKey,
  TransactionReverseVariables
>({
  method: 'post',
  name: 'transactionReverse',
  summary: 'Reverse transaction',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}/reverse',
  queryKey: ({ query, personId, loanId, transactionId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'reverse',
    query,
  ],
})

export type GetChargebacksKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  unknown,
]

export type GetChargebacksResponse = ResponseTypes.Chargebacks

export type GetChargebacksVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: void
}

export const getChargebacks = makeData<
  GetChargebacksResponse,
  GetChargebacksKey,
  GetChargebacksVariables
>({
  method: 'get',
  name: 'getChargebacks',
  summary: 'Get transaction chargebacks',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks',
  queryKey: ({ query, personId, loanId, transactionId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    query,
  ],
})

export type TransactionChargebackKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  unknown,
]

export type TransactionChargebackResponse = ResponseTypes.Chargeback

export type TransactionChargebackVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: RequestBodyTypes.ChargebackPost
  query?: {
    sync?: boolean
  }
}

export const transactionChargeback = makeData<
  TransactionChargebackResponse,
  TransactionChargebackKey,
  TransactionChargebackVariables
>({
  method: 'post',
  name: 'transactionChargeback',
  summary: 'Create transaction chargeback',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks',
  queryKey: ({ query, personId, loanId, transactionId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    query,
  ],
})

export type GetChargebackByIdKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  string | undefined,
  unknown,
]

export type GetChargebackByIdResponse = ResponseTypes.Chargeback

export type GetChargebackByIdVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  chargebackId: string | undefined
  body?: void
  query?: void
}

export const getChargebackById = makeData<
  GetChargebackByIdResponse,
  GetChargebackByIdKey,
  GetChargebackByIdVariables
>({
  method: 'get',
  name: 'getChargebackById',
  summary: 'Get chargeback by ID',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks/{chargebackId}',
  queryKey: ({ query, personId, loanId, transactionId, chargebackId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    chargebackId,
    query,
  ],
})

export type UpdateChargebackKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  string | undefined,
  unknown,
]

export type UpdateChargebackResponse = ResponseTypes.Chargeback

export type UpdateChargebackVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  chargebackId: string | undefined
  body?: RequestBodyTypes.ChargebackPut
  query?: {
    sync?: boolean
  }
}

export const updateChargeback = makeData<
  UpdateChargebackResponse,
  UpdateChargebackKey,
  UpdateChargebackVariables
>({
  method: 'put',
  name: 'updateChargeback',
  summary: 'Update chargeback',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks/{chargebackId}',
  queryKey: ({ query, personId, loanId, transactionId, chargebackId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    chargebackId,
    query,
  ],
})

export type TransactionBackdateKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'backdate',
  unknown,
]

export type TransactionBackdateResponse = void

export type TransactionBackdateVariables = {
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: {
    /** New effective date for the transaction. */
    effectiveDate: string
    effectiveTimeOfDay?: SchemaTypes.TimeOfDay & /**
     * The effective time of day on effectiveDate in the product timezone. If the time of day is not provided, the Peach system will set the time of
     * day based on the following logic:
     *
     * - If backdated to the loan activation date, the system will set the timestamp to the activation timestamp plus a few seconds.
     * - If backdated to a loan non-activation date, the system will set the timestamp to a few minutes after the loan accrued interest on the effectiveDate.
     */ {}
    /** The identifier of an existing case. */
    caseId?: string
  }
  query?: {
    sync?: boolean
  }
}

export const transactionBackdate = makeData<
  TransactionBackdateResponse,
  TransactionBackdateKey,
  TransactionBackdateVariables
>({
  method: 'post',
  name: 'transactionBackdate',
  summary: 'Backdate transaction',
  path: '/people/{personId}/loans/{loanId}/transactions/{transactionId}/backdate',
  queryKey: ({ query, personId, loanId, transactionId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'backdate',
    query,
  ],
})

export type AliasLoanTransactionsGetAllKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  unknown,
]

export type AliasLoanTransactionsGetAllResponse =
  ResponseTypes.TransactionCollection

export type AliasLoanTransactionsGetAllVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: {
    /**
     * @default
     *     25
     */
    limit?: number
    startingAfter?: string
    endingBefore?: string
    parentTransactionId?: SchemaTypes.AnyId
    status?: Array<SchemaTypes.TransactionStatusReadOnly>
    isExternal?: boolean
    isVirtual?: boolean
    isInFlightPayment?: boolean
    transactionType?: 'payment' | 'serviceCredit'
    serviceCreditTypes?: Array<SchemaTypes.serviceCreditTypes>
    toEffectiveDate?: string
    fromEffectiveDate?: string
    sortBy?: Array<
      | 'appliedAt'
      | '+appliedAt'
      | '-appliedAt'
      | 'createdAt'
      | '+createdAt'
      | '-createdAt'
      | 'effectiveDate'
      | '+effectiveDate'
      | '-effectiveDate'
      | 'displayDate'
      | '+displayDate'
      | '-displayDate'
    >
  }
}

export const aliasLoanTransactionsGetAll = makeData<
  AliasLoanTransactionsGetAllResponse,
  AliasLoanTransactionsGetAllKey,
  AliasLoanTransactionsGetAllVariables
>({
  method: 'get',
  name: 'aliasLoanTransactionsGetAll',
  summary: 'Get transactions',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    query,
  ],
})

export type InternalTransactionsCreateKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  unknown,
]

export type InternalTransactionsCreateResponse =
  UtilityTypes.SingletonResponse & {
    data?: SchemaTypes.Transaction
  }

export type InternalTransactionsCreateVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: SchemaTypes.CreateTransactionInternal
  query?: {
    sync?: boolean
  }
}

export const internalTransactionsCreate = makeData<
  InternalTransactionsCreateResponse,
  InternalTransactionsCreateKey,
  InternalTransactionsCreateVariables
>({
  method: 'post',
  name: 'internalTransactionsCreate',
  summary: 'Create transaction',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    query,
  ],
})

export type AliasTransactionsGetByIdKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  unknown,
]

export type AliasTransactionsGetByIdResponse =
  UtilityTypes.SingletonResponse & {
    data?: SchemaTypes.Transaction
  }

export type AliasTransactionsGetByIdVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: void
}

export const aliasTransactionsGetById = makeData<
  AliasTransactionsGetByIdResponse,
  AliasTransactionsGetByIdKey,
  AliasTransactionsGetByIdVariables
>({
  method: 'get',
  name: 'aliasTransactionsGetById',
  summary: 'Get transaction by ID',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    query,
  ],
})

export type AliasTransactionsUpdateKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  unknown,
]

export type AliasTransactionsUpdateResponse = UtilityTypes.SingletonResponse & {
  data?: SchemaTypes.Transaction
}

export type AliasTransactionsUpdateVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: SchemaTypes.TransactionUpdateInternal
  query?: {
    sync?: boolean
  }
}

export const aliasTransactionsUpdate = makeData<
  AliasTransactionsUpdateResponse,
  AliasTransactionsUpdateKey,
  AliasTransactionsUpdateVariables
>({
  method: 'put',
  name: 'aliasTransactionsUpdate',
  summary: 'Update transaction',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    query,
  ],
})

export type AliasTransactionCancelKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'cancel',
  unknown,
]

export type AliasTransactionCancelResponse = void

export type AliasTransactionCancelVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: {
    cancelReason?: SchemaTypes.TransactionCancelReason
    clearExternalId?: boolean
  }
}

export const aliasTransactionCancel = makeData<
  AliasTransactionCancelResponse,
  AliasTransactionCancelKey,
  AliasTransactionCancelVariables
>({
  method: 'post',
  name: 'aliasTransactionCancel',
  summary: 'Cancel transaction',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/cancel',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'cancel',
    query,
  ],
})

export type AliasTransactionsFailMultipleKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  'fail',
  unknown,
]

export type AliasTransactionsFailMultipleResponse =
  TransactionsPublicTypes.ResponseFailMultipleTransactions

export type AliasTransactionsFailMultipleVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: TransactionsPublicTypes.RequestBodyFailMultipleTransactions
  query?: {
    sync?: boolean
  }
}

export const aliasTransactionsFailMultiple = makeData<
  AliasTransactionsFailMultipleResponse,
  AliasTransactionsFailMultipleKey,
  AliasTransactionsFailMultipleVariables
>({
  method: 'post',
  name: 'aliasTransactionsFailMultiple',
  summary: 'Fail multiple transactions',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/fail',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    'fail',
    query,
  ],
})

export type AliasTransactionReverseKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'reverse',
  unknown,
]

export type AliasTransactionReverseResponse = void

export type AliasTransactionReverseVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: RequestBodyTypes.ReversalPost
  query?: {
    sync?: boolean
  }
}

export const aliasTransactionReverse = makeData<
  AliasTransactionReverseResponse,
  AliasTransactionReverseKey,
  AliasTransactionReverseVariables
>({
  method: 'post',
  name: 'aliasTransactionReverse',
  summary: 'Reverse transaction',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/reverse',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'reverse',
    query,
  ],
})

export type AliasGetChargebacksKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  unknown,
]

export type AliasGetChargebacksResponse = ResponseTypes.Chargebacks

export type AliasGetChargebacksVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: void
  query?: void
}

export const aliasGetChargebacks = makeData<
  AliasGetChargebacksResponse,
  AliasGetChargebacksKey,
  AliasGetChargebacksVariables
>({
  method: 'get',
  name: 'aliasGetChargebacks',
  summary: 'Get transaction chargebacks',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    query,
  ],
})

export type AliasTransactionChargebackKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  unknown,
]

export type AliasTransactionChargebackResponse = void

export type AliasTransactionChargebackVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  body?: RequestBodyTypes.ChargebackPost
  query?: {
    sync?: boolean
  }
}

export const aliasTransactionChargeback = makeData<
  AliasTransactionChargebackResponse,
  AliasTransactionChargebackKey,
  AliasTransactionChargebackVariables
>({
  method: 'post',
  name: 'aliasTransactionChargeback',
  summary: 'Create transaction chargeback',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks',
  queryKey: ({ query, companyId, personId, loanId, transactionId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    query,
  ],
})

export type AliasGetChargebackByIdKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  string | undefined,
  unknown,
]

export type AliasGetChargebackByIdResponse = ResponseTypes.Chargeback

export type AliasGetChargebackByIdVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  chargebackId: string | undefined
  body?: void
  query?: void
}

export const aliasGetChargebackById = makeData<
  AliasGetChargebackByIdResponse,
  AliasGetChargebackByIdKey,
  AliasGetChargebackByIdVariables
>({
  method: 'get',
  name: 'aliasGetChargebackById',
  summary: 'Get chargeback by ID',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks/{chargebackId}',
  queryKey: ({
    query,
    companyId,
    personId,
    loanId,
    transactionId,
    chargebackId,
  }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    chargebackId,
    query,
  ],
})

export type AliasUpdateChargebackKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'transactions',
  string | undefined,
  'chargebacks',
  string | undefined,
  unknown,
]

export type AliasUpdateChargebackResponse = ResponseTypes.Chargeback

export type AliasUpdateChargebackVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  transactionId: string | undefined
  chargebackId: string | undefined
  body?: RequestBodyTypes.ChargebackPut
  query?: {
    sync?: boolean
  }
}

export const aliasUpdateChargeback = makeData<
  AliasUpdateChargebackResponse,
  AliasUpdateChargebackKey,
  AliasUpdateChargebackVariables
>({
  method: 'put',
  name: 'aliasUpdateChargeback',
  summary: 'Update chargeback',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/transactions/{transactionId}/chargebacks/{chargebackId}',
  queryKey: ({
    query,
    companyId,
    personId,
    loanId,
    transactionId,
    chargebackId,
  }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'transactions',
    transactionId,
    'chargebacks',
    chargebackId,
    query,
  ],
})
